// extracted by mini-css-extract-plugin
export var avatarContainer = "_5i-1";
export var largeAvatarContainer = "_5i-2";
export var smallAvatarContainer = "_5i-0";